<template>
  <Dialog
    v-model="isOpen"
    v-bind="$attrs"
    max-width="800px"
    :persistent="reportIsLoading"
  >
    <template
      v-if="dataLoading"
      #content
    >
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </div>
    </template>
    <template
      v-else
      #content
    >
      <div
        v-if="!reports || reports.length === 0"
        class="d-flex justify-center"
      >
        {{ $t("No reports found") }}
      </div>
      <OrderReportDownload
        v-else
        max-width="800px"
        v-model="isOpen"
        :loaded-value="loadedValue"
        :reports="reports"
        report-type="reports"
        @isLoading="loading"
      />
    </template>

    <template #actions>
      <Button
        :label="$t('Close')"
        class="text-white"
        :disabled="reportIsLoading"
        @click="$emit('update:modelValue', false)"
      />
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { ref, computed } from "vue";
import Dialog from "@/components/dialogs/Dialog.vue";
import Button from "@/components/input-components/Button.vue";
import OrderReportDownload from "@/components/orders/OrderReportDownload.vue";

defineOptions({ name: "ReportDownloadDialog", inheritAttrs: false });

const props = defineProps({
  dataLoading: { type: Boolean, required: true, default: false },
  modelValue: { type: Boolean, required: true },
  reports: { type: Array as () => any[], required: true, default: () => [] },
  loadedValue: { type: Number, required: false, default: null },
});

const emit = defineEmits<{
  input: [value: boolean]
  "update:modelValue": [value: boolean]
}>()

const isOpen = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit("update:modelValue", val),
});
const reportIsLoading = ref(false);

const loading = (isLoading: boolean) => {
  reportIsLoading.value = isLoading;
};
</script>

